export const getKey = (prefix: string, identifier: number | string) => {
    return `${prefix}-${identifier}`;
  };